import useTranslator from "../../hooks/useTranslator";
import { Tooltip as ReactTooltip } from "react-tooltip";
import styles from "./NoteForLandlord.module.css";

const NoteForLandlord = ({
  note,
  onEditNote,
  disabled = false,
  processing = false,
}) => {
  const { _t } = useTranslator();
  const tooltipText = processing
    ? _t(
        "profileProcessingWait",
        "Your profile is still being processed. Please wait until it's ready."
      )
    : disabled
      ? _t(
          "profileOutdatedRenewFirst",
          "Your profile is outdated. Please renew your profile first."
        )
      : undefined;

  return (
    <section
      className="tenant-profile-placeholder-card tenant-profile-placeholder-card--landlord-note"
      aria-labelledby="note-for-landlord-title"
    >
      <h2 id="note-for-landlord-title">
        {_t("noteForLandlord", "Note for landlord")}
      </h2>
      <p className={styles.subtitle}>
        {_t(
          "noteForLandlordPlaceholder",
          "Doesn't affect your completeness, but landlords read it."
        )}
      </p>
      <div className={styles.noteWrap}>
        {onEditNote &&
          (disabled ? (
            <div
              data-tooltip-id="nfl-edit-tooltip"
              style={{
                position: "absolute",
                top: "10px",
                right: "12px",
                display: "inline-block",
              }}
            >
              <button
                type="button"
                className={styles.editBtn}
                onClick={onEditNote}
                disabled={disabled}
                style={{
                  position: "static",
                  opacity: 0.5,
                  cursor: "not-allowed",
                }}
                aria-label={_t("edit", "Edit")}
              >
                {_t("edit", "Edit")}
              </button>
              <ReactTooltip
                id="nfl-edit-tooltip"
                place="top"
                className="react-tooltip-styling"
                render={() => <p>{tooltipText}</p>}
              />
            </div>
          ) : (
            <button
              type="button"
              className={styles.editBtn}
              onClick={onEditNote}
              aria-label={_t("edit", "Edit")}
            >
              {_t("edit", "Edit")}
            </button>
          ))}
        <p className={`${styles.note} ${!note ? styles.empty : ""}`}>
          {note || _t("noInformation", "No information")}
        </p>
      </div>
    </section>
  );
};

export default NoteForLandlord;
